// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.industries-section {
  padding: 60px 0;
  background: #f8f9fb;
}

.industry-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 30px;
}

.industry-header .bar {
  width: 4px;
  height: 24px;
  background: #ff9f00;
  margin-top: -8px;
}

.industry-header h2 {
  font-size: 1.4rem;
  font-weight: 600;
  letter-spacing: 1px;
  color:rgb(55 65 81 / var(--tw-text-opacity, 1))
}

.industry-card {
  position: relative;
  display: block;
  border-radius: 14px;
  overflow: hidden;
  height: 220px;
}

.industry-card img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.industry-title {
  position: absolute;
  bottom: 16px;
  left: 16px;
  background: rgba(0, 0, 0, 0.6);
  color: #fff;
  padding: 8px 16px;
  border-radius: 6px;
  font-size: 1rem;
  font-weight: 500;
}

/* Card container */
.industry-card {
  position: relative;
  display: block;
  border-radius: 18px;
  overflow: hidden;              /* VERY IMPORTANT */
  height: 220px;
  box-shadow: 0 10px 25px rgba(0,0,0,0.15);
  transition: transform 0.35s ease;
  text-decoration: none;
}

/* Image */
.industry-card img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.6s ease;
}

/* Image zoom on hover */
.industry-card:hover img {
  transform: scale(1.15);
}

/* Optional card lift */
.industry-card:hover {
  transform: translateY(-6px);
}

/* Dark overlay for readability */
.industry-card::after {
  content: "";
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.25);
  opacity: 0;
  transition: opacity 0.35s ease;
}

.industry-card:hover::after {
  opacity: 1;
}

/* Title on image */
.industry-title {
  position: absolute;
  bottom: 16px;
  left: 16px;
  z-index: 2;
  color: #ffffff;
  font-size: 18px;
  font-weight: 600;
  text-transform: capitalize;
}

/* Mobile safe (disable hover zoom) */
@media (hover: none) {
  .industry-card:hover img {
    transform: none;
  }
}

`, "",{"version":3,"sources":["webpack://./src/assets/styles/industries.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB;AACF;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,8BAA8B;EAC9B,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,gBAAgB,eAAe,mBAAmB;EAClD,aAAa;EACb,wCAAwC;EACxC,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA,UAAU;AACV;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA,wBAAwB;AACxB;EACE,sBAAsB;AACxB;;AAEA,uBAAuB;AACvB;EACE,2BAA2B;AAC7B;;AAEA,iCAAiC;AACjC;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,+BAA+B;EAC/B,UAAU;EACV,8BAA8B;AAChC;;AAEA;EACE,UAAU;AACZ;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,UAAU;EACV,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA,qCAAqC;AACrC;EACE;IACE,eAAe;EACjB;AACF","sourcesContent":[".industries-section {\r\n  padding: 60px 0;\r\n  background: #f8f9fb;\r\n}\r\n\r\n.industry-header {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  margin-bottom: 30px;\r\n}\r\n\r\n.industry-header .bar {\r\n  width: 4px;\r\n  height: 24px;\r\n  background: #ff9f00;\r\n  margin-top: -8px;\r\n}\r\n\r\n.industry-header h2 {\r\n  font-size: 1.4rem;\r\n  font-weight: 600;\r\n  letter-spacing: 1px;\r\n  color:rgb(55 65 81 / var(--tw-text-opacity, 1))\r\n}\r\n\r\n.industry-card {\r\n  position: relative;\r\n  display: block;\r\n  border-radius: 14px;\r\n  overflow: hidden;\r\n  height: 220px;\r\n}\r\n\r\n.industry-card img {\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: cover;\r\n}\r\n\r\n.industry-title {\r\n  position: absolute;\r\n  bottom: 16px;\r\n  left: 16px;\r\n  background: rgba(0, 0, 0, 0.6);\r\n  color: #fff;\r\n  padding: 8px 16px;\r\n  border-radius: 6px;\r\n  font-size: 1rem;\r\n  font-weight: 500;\r\n}\r\n\r\n/* Card container */\r\n.industry-card {\r\n  position: relative;\r\n  display: block;\r\n  border-radius: 18px;\r\n  overflow: hidden;              /* VERY IMPORTANT */\r\n  height: 220px;\r\n  box-shadow: 0 10px 25px rgba(0,0,0,0.15);\r\n  transition: transform 0.35s ease;\r\n  text-decoration: none;\r\n}\r\n\r\n/* Image */\r\n.industry-card img {\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: cover;\r\n  transition: transform 0.6s ease;\r\n}\r\n\r\n/* Image zoom on hover */\r\n.industry-card:hover img {\r\n  transform: scale(1.15);\r\n}\r\n\r\n/* Optional card lift */\r\n.industry-card:hover {\r\n  transform: translateY(-6px);\r\n}\r\n\r\n/* Dark overlay for readability */\r\n.industry-card::after {\r\n  content: \"\";\r\n  position: absolute;\r\n  inset: 0;\r\n  background: rgba(0, 0, 0, 0.25);\r\n  opacity: 0;\r\n  transition: opacity 0.35s ease;\r\n}\r\n\r\n.industry-card:hover::after {\r\n  opacity: 1;\r\n}\r\n\r\n/* Title on image */\r\n.industry-title {\r\n  position: absolute;\r\n  bottom: 16px;\r\n  left: 16px;\r\n  z-index: 2;\r\n  color: #ffffff;\r\n  font-size: 18px;\r\n  font-weight: 600;\r\n  text-transform: capitalize;\r\n}\r\n\r\n/* Mobile safe (disable hover zoom) */\r\n@media (hover: none) {\r\n  .industry-card:hover img {\r\n    transform: none;\r\n  }\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
